<template>
  <div>Success! You may now close this window.</div>
</template>

<script>
export default {
  mounted() {
    window.close();
  }
};
</script>
